/**
 * Normalizes tenant service_provider payloads after the platform status migration.
 * Legacy clients treat `status` as a boolean organisation-active flag.
 */
export const normalizeServiceProviderForClient = (serviceProvider) => {
  if (!serviceProvider || typeof serviceProvider !== "object") {
    return serviceProvider;
  }

  const hasLegacyBooleanStatus = typeof serviceProvider.status === "boolean";

  const tenantStatus =
    typeof serviceProvider.tenant_status === "string"
      ? serviceProvider.tenant_status
      : typeof serviceProvider.status === "string"
        ? serviceProvider.status
        : hasLegacyBooleanStatus
          ? serviceProvider.status
            ? "active"
            : "archived"
          : "active";

  const accountEnabled =
    serviceProvider.account_enabled !== undefined
      ? Boolean(serviceProvider.account_enabled)
      : hasLegacyBooleanStatus
        ? serviceProvider.status
        : tenantStatus === "active";

  const isOperational = accountEnabled && tenantStatus === "active";

  return {
    ...serviceProvider,
    account_enabled: accountEnabled,
    tenant_status: tenantStatus,
    status: isOperational,
  };
};
